import { Location } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';
import { FileManager_API, FileManager_PATH } from "../../constants";
import { BaseComponent } from '../../core/components';


@Component({
    selector: 'app-file-manager',
    templateUrl: './file-manager.component.html',
    styleUrls: ['./file-manager.component.scss']
})
export class FileManagerComponent extends BaseComponent implements OnInit, AfterViewInit {
    public link: string = FileManager_PATH
    //https://filemanager.serapp.com/ser4/FileManager.aspx
    public link2: string = `${FileManager_API}/FileManagerForModal.aspx`;
    showSpinner: boolean = false;
    isFullpage: boolean = false

    constructor(private route: ActivatedRoute,
        private router: Router,
        private location: Location) {
        super(router);
    }

    public ngOnInit() {
        this.isFullpage = this.route.snapshot.data?.fullpage ?? false
        this.showSpinner = true;
        let currentUser = super.currentLoggedUser();
        this.route.params.subscribe((params) => {
            if (!params) {
                return;
            }
            const id = params['moduleId'];
            if (this.type == 'normal') {
                if (id) {
                    this.link = FileManager_PATH + '?userId=' + currentUser.id + '&moduleId=' + id + '&isTemplate=' + this.isTemplate + '&token=' + btoa(window.location.origin);
                }
                else {
                    this.link = FileManager_PATH + '?userId=' + currentUser.id + '&moduleId=' + this.moduleId + '&isTemplate=' + this.isTemplate + '&token=' + btoa(window.location.origin) + '' + this.options;
                }
            } else {
                if (id) {
                    this.link = this.link2 + '?userId=' + currentUser.id + '&moduleId=' + id + '&isTemplate=' + this.isTemplate + '&token=' + btoa(window.location.origin);
                }
                else {
                    this.link = this.link2 + '?userId=' + currentUser.id + '&moduleId=' + this.moduleId + '&isTemplate=' + this.isTemplate + '&token=' + btoa(window.location.origin) + '' + this.options;
                }
            }

        });
    }

    loaded() {
        this.showSpinner = false;
    }

    public ngAfterViewInit() {
        console.log(btoa(window.location.origin));
    }

    @Input("module-id") moduleId: number = 0;
    @Input("options") options: string = '';
    @Input("height") height: string = '';
    @Input("type") type: string = 'normal';
    @Input("isTemplate") isTemplate: boolean = true
}



// WEBPACK FOOTER //
// ./src/app/components/file-manager/file-manager.component.ts